// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"aM-z","carouselContainer":"bM-z"};